import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { enumText, translate, downloadFile } from '../../../utils/util';
import { ENUMS } from '../../../utils/constants';
import { connect } from 'react-redux';
import PackListService from '../../../services/PackListService';

const ListOrder = (props) => {
    const getStatus = (value) => translate(`${enumText(ENUMS.ePackListStatus, value)}`);


    return (
        <>
          <Link
                className="row"
                style={{ display: 'block', marginBottom: '0px', marginLeft: '10px' }}
                to={{ pathname: './listorderitem', state: { order: props.data  }
                }}
            >
                {props.data.packListId === null ||
                    (props.data.packList.status === ENUMS.ePackListStatus.ReprovedFinance.value
                        || props.data.packList.status === ENUMS.ePackListStatus.ReprovedPatrimonial.value
                    ) ?

                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                    ><i onClick={(event) => {
                        event.preventDefault();
                        let packList = { orderId: props.data.orderId};
                        props.createPackList(packList);

                    }}
                        className={`mdi mdi-36px mdi-call-made green-text`} />
                    </span> : null
                }
                {props.data.packListId != null &&
                    (props.data.packList.status === ENUMS.ePackListStatus.PendingFinance.value
                        || props.data.packList.status === ENUMS.ePackListStatus.PropertyPending.value
                    ) ?
                    <div>
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                        ><i onClick={(event) => {
                            event.preventDefault();
                            let packList = { id: props.data.packListId };
                            props.approve(packList);

                        }}
                            className={`mdi mdi-36px mdi-checkbox-marked-circle-outline green-text`} />
                        </span>
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '40px', right: '10px', zIndex: '999' }}
                        ><i onClick={(event) => {
                            event.preventDefault();
                            let packList = { id: props.data.packListId };
                            props.reprove(packList);

                        }}
                            className={`mdi mdi-36px mdi-alpha-x-circle-outline red-text`} />
                        </span>
                    </div> : null
                }
                {props.data.packListId != null && props.data.packList.status === ENUMS.ePackListStatus.PackListAuthorized.value
                    &&
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                    ><i onClick={(event) => {
                        event.preventDefault();
                        event.preventDefault();
                        let packList = { id: props.data.packListId };
                        props.reportPdf(packList, (data) => {
                            downloadFile(data, `romaneio${props.data.packListId}.pdf`, "data:application/pdf", true);
                        });
                    }}
                        className={`mdi mdi-36px mdi-printer`} />
                    </span>
                }
                <div className="row" style={{ display: 'block', marginBottom: '0px' }} >
                    <span className="title sixth-text-color">
                        {props.data.orderCode}
                    </span>
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                        {props.data.supplierCode}
                    </span>
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                        {props.data.supplierName}
                    </span>
                    <div className="col s12 " style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px', padding: '0px' }}>
                            {props.data.items.length}
                        </span>
                    </div>
                    {props.data.packListId != null ?
                        <>
                            <div className="col s12 " style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                                    <i className='mdi mdi-clipboard-list-outline'></i>  {props.data.packListId}
                                </span>
                            </div>
                            <div className="col s12 " style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                                    {getStatus(props.data.packList.status)}
                                </span>
                            </div>
                        </>
                        : <div className="col s12 " style={{ padding: '0px' }}>
                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }} >
                                {translate(`expedition:picking.pack-list-status.collected`)}
                            </span>
                        </div>
                    }
                </div>
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reportPdf: (filter, callback) => {
            dispatch(PackListService.reportPdf(filter, callback));
        }
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListOrder)));
